// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"691":"c175d243","795":"c175d243","882":"c175d243","893":"c175d243","914":"c175d243","919":"c175d243"}[chunkId] + ".chunk.css";
};